import React from "react";
import { Button, Dropdown } from "react-bootstrap";

const ColorPicker = ({ colors, onColorSelect, selectedColor }) => {
  return (
    <div className="d-flex flex-column align-items-center gap-3 p-3 border rounded shadow-sm bg-light">
      <div
        className="d-flex flex-wrap justify-content-start gap-2"
        style={{ maxWidth: "150px" }}
      >
        {colors.map((color, index) => (
          <div
            key={index}
            style={{
              backgroundColor: color,
              borderColor: color,
              width: "40px",
              height: "40px",
              boxShadow:
                selectedColor === color
                  ? "0px 0px 8px 4px rgba(0, 0, 0, 0.3)"
                  : "none",
              transform: selectedColor === color ? "scale(1.2)" : "scale(1)",
              transition: "all 0.2s ease-in-out",
            }}
            className={`rounded-circle p-0 border-0 ${
              selectedColor === color ? "border border-dark" : ""
            }`}
            onClick={() => onColorSelect(color)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;
